// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__280Pz","amount":"Amount_amount__3jT-6","tip":"Amount_tip__3DxwE","tipHeader":"Amount_tipHeader__3pdHq","tipsWrap":"Amount_tipsWrap__2hEtM"};